import { createCrudSagas } from "./CrudSagas";
import { ContextDefinitionsActions } from "../reducers/ContextDefinitionsRedux";

const crudSagas = createCrudSagas("contextDefinitions", ContextDefinitionsActions);

export const findContextDefinitions = crudSagas.findContextDefinitions;
export const getContextDefinition = crudSagas.getContextDefinition;
export const watchContextDefinitions = crudSagas.watchContextDefinitions;
export const unwatchContextDefinitions = crudSagas.unwatchContextDefinitions;